var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.waiting),expression:"waiting"}],staticClass:"waiting"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waiter"},[_c('div',{staticClass:"inner one"}),_c('div',{staticClass:"inner two"}),_c('div',{staticClass:"inner three"})])
}]

export { render, staticRenderFns }